import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4hfzm6sugt: FaireBrandEntity = {
  token: "b_4hfzm6sugt",
  type: "brand",
  name: "GirlyPirateCo",
  avatarUrl:
    "https://cdn.faire.com/fastly/1c7f48955f82b40beca636d595e057512057e20d708eebe97349dcf67dd58924.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/890f7abf0ab34a3a0bf2de77904b28e3d742162dee3b2c5e7e479011933816a4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1c7f48955f82b40beca636d595e057512057e20d708eebe97349dcf67dd58924.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/890f7abf0ab34a3a0bf2de77904b28e3d742162dee3b2c5e7e479011933816a4.jpeg",
  location: "WESLEY CHAPEL, FL, USA",
  minimumOrderDollars: 69,
  rating: 4.9,
  reviewCount: 7,
  isTopShop: true,
  isInsider: true,
  description:
    "GirlyPirateCo is a newly established company specializing in integrated design and production. Our primary focus is on a wide range of jewelry, including for adults, children, and even pets. We are highly dedicated and passionate about our products, striving to provide excellent service to each of our customers. Currently, most of our products have been well-received in the market, and we are confident in our ability to help our clients expand their businesses further.\nWe’re new to Faire and still building our reviews, so now we’re offering our products at very low prices. Our goal is to let more buyers discover the quality and style of our designs—don’t miss this chance to stock up early for the holiday season!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:46.927Z",
    importedBy: "entity-db-cli",
  },
};
